'use strict';

angular.module('app').directive('triggerTypeahead', function ($timeout) {
  function linkFunc(scope, attrs, element, ngModel) {
    scope.$watch('triggerTypeahead', function () {
      if (ngModel.$viewValue) {
        $(element).focus();
        var old = ngModel.$viewValue;
        ngModel.$setViewValue('');

        $timeout(function () {
          ngModel.$setViewValue(old);
          // ngModel.$render();
          scope.triggerMessage = false;
        });
      }
    });
  }
  return {
    link: linkFunc,
    require: 'ngModel',
    restrict: 'A',
    scope: {
      triggerTypeahead: '=',
      triggerMessage: '=',
    },
  };
});

angular.module('app').directive('selectTextOnClick', function () {
  return function () {
    $(document).on('focus', '.autosuggest', function (e) {
      var _this = this;
      setTimeout(function () {
        try {
          _this.setSelectionRange(0, _this.value.length);
        } catch (err) {
          // Non IOs option if not supported, e.g. Chrome
          _this.select();
        }
      }, 10);
    });
  };
});

'use strict';

angular.module('app').directive('triggerTypeaheadOnClick', function ($timeout) {
  function linkFunc(scope, attrs, element, ngModel) {
    $('.autosuggest').click(function () {
      if (ngModel.$viewValue) {
        var old = ngModel.$viewValue;
        ngModel.$setViewValue(old.slice(0, -1));

        $timeout(function () {
          ngModel.$setViewValue(old);
          scope.triggerMessage = false;
        });
      }
    });
  }
  return {
    link: linkFunc,
    require: 'ngModel',
    restrict: 'A',
    scope: {
      triggerTypeahead: '=',
      triggerMessage: '=',
    },
  };
});
